<template>
    <table class="table-principal">
        <thead>
        <b-row class="table-tr-hearder">
            <b-col
                    cols="2"
                    v-for="(col, index) in columns"
                    :key="index"
                    @click="sortBy(col.key)"
                    :style="col.key === 'carrera'? 'max-width: 19% !important;text-align: left;padding-left: 2rem;' : ''"
                    :lg="col.width"
                    class="table-th"
                    :class="{ active: sortKey == col.key }"
            >
                <span>{{ col.name | capitalize }}</span>
                <!--<span class="arrow" :class="sortOrders[col.key] > 0 ? 'asc' : 'dsc'">-->
                <!--</span>-->
            </b-col>
        </b-row>
        </thead>
        <tbody class="table-tbody">
        <b-row class="table-tr" v-for="(entry, ind) in filteredData" :key="ind">
            <b-col
                    v-for="(col, index) in columns"
                    :key="index"
                    :lg="col.width"
                    :style="col.key==='boton'? 'width: 29rem !important;': ''"
                    :class="col.class"
            >
          <span
                  v-if="col.key !== 'estado' && col.key!=='boton'"
                  :class="col.class_text"
          >{{entry[col.key]}}</span>
                <span
                        v-if="col.key === 'estado' && col.key!=='boton'"
                        :class="entry[col.key] === 'Completado' ? 'table-text-completo' : 'table-text-incompleto'"
                >{{entry[col.key]}}</span>
                <button
                        v-if="col.key==='boton'"
                        :class="!isAsesor ? 'button-primary-result-student' : 'button-primary-result-student-report'"
                        @click="goRouter(content.url, entry['id'])"
                >
                    <span class="button-text-result-student">{{ content.button }}</span>
                </button>
            </b-col>
        </b-row>
        </tbody>
    </table>
</template>
<script>
    export default {
        name: "Navbar",
        props: {
            data: Array,
            columns: Array,
            filterKey: String,
            content: Object
        },
        data: function () {
            var sortOrders = {};
            this.columns.forEach(function (col) {
                sortOrders[col.key] = 1;
            });
            return {
                sortKey: "",
                sortOrders: sortOrders
            };
        },
        computed: {
            isAsesor() {
                return this.$store.getters["isAsesor"];
            },
            filteredData: function () {
                var sortKey = this.sortKey;
                var filterKey = this.filterKey && this.filterKey.toLowerCase();
                var order = this.sortOrders[sortKey] || 1;
                var data = this.data;
                if (filterKey) {
                    data = data.filter(function (row) {
                        return Object.keys(row).some(function (key) {
                            return (
                                String(row[key])
                                    .toLowerCase()
                                    .indexOf(filterKey) > -1
                            );
                        });
                    });
                }
                if (sortKey) {
                    data = data.slice().sort(function (a, b) {
                        a = a[sortKey];
                        b = b[sortKey];
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    });
                }
                return data;
            }
        },
        filters: {
            capitalize: function (str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        },
        methods: {
            sortBy: function (key) {
                //                console.log('aqui:', key)
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
                console.log("sortBy:", this.sortOrders[key]);
            },
            goRouter(url, id) {
                //                console.log('url:', url)
                localStorage.id_estudiante = id;
                this.$router.push(url);
            }
        }
    };
</script>
<style scoped>
</style>
